/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.RoutingCandidateUsersService
 */

export const getRoutingCandidateUsersRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.RoutingCandidateUsersService',
  rpcName: 'getRoutingCandidateUsers',
  auth: 'app',
  fingerprint: 'WHI25D6MoZIjNG2ykUzG8KXvt8AUhX45',
  na1Only: false,
  isStreaming: false
};